module.exports = __webpack_public_path__ + "static/media/IMG_8028.e8791045.jpg";